var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('modal',{ref:"modalMapaCedis",attrs:{"titulo":"Ubicación de cedis","height":60,"fix-height":60,"tamano":"modal-xl","icon":"location","no-aceptar":"","no-cancelar":"","btns":_vm.btns,"cargando":_vm.loading}},[_c('div',{staticStyle:{"height":"calc(100% - 1px)"}},[_c('mapa-google',{ref:"GoogleMaps",attrs:{"height":"100%"}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }